export default __webpack_public_path__ + "static/safecheck-stop-a0f90d10600eec80a4a359cf1a1abea4.svg";